import { render, staticRenderFns } from "./failureReport.vue?vue&type=template&id=687f5620&scoped=true&"
import script from "./failureReport.vue?vue&type=script&lang=js&"
export * from "./failureReport.vue?vue&type=script&lang=js&"
import style0 from "./failureReport.vue?vue&type=style&index=0&id=687f5620&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687f5620",
  null
  
)

export default component.exports